module.exports = global["reduxActionTypes"] = require("-!/builds/bv-com/web/frontend/node_modules/babel-loader/lib/index.js??ref--10-0!./action_types.js");